import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormlyModule } from '@ngx-formly/core';

import { ISPFieldWrapper } from 'common/dynamic-form/model/field-wrapper.enum';

import { FieldButtonsModule } from './buttons/buttons.module';
import { FieldDescriptionModule } from './description/description.module';
import { FieldBaseComponent } from './field-base.component';
import { FieldHintModule } from './hint/hint.module';
import { FieldPlainHintModule } from './plain-hint/plain-hint.module';
import { FieldTagModule } from './tag/tag.module';

/**
 * Field base wrapper
 */
@NgModule({
  declarations: [FieldBaseComponent],
  imports: [
    CommonModule,
    FieldButtonsModule,
    FieldHintModule,
    FieldPlainHintModule,
    FieldDescriptionModule,
    FieldTagModule,
    FormlyModule.forChild({
      wrappers: [
        { name: ISPFieldWrapper.FieldBase, component: FieldBaseComponent },
      ],
    }),
  ],
})
export class FieldBaseModule {}
